module.exports = __webpack_public_path__ + "static/thumbnail-10ceb94a319b8440786cf9432beb11e5.jpg";